import { render } from "./index.vue?vue&type=template&id=4b256aa6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/news-and-seminars-detail/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b256aa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b256aa6', __exports__)) {
    api.reload('4b256aa6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4b256aa6", () => {
    api.rerender('4b256aa6', render)
  })

}


export default __exports__